const SHEET_NAME = "Hoja1";

const COLUMNS = [
	{ header: "Fecha", key: "fecha", width: 11.71 },
	{ header: "RFCTE", key: "rfcte", width: 15.71 },
	{ header: "Nombre empresa", key: "nombreEmpresa", width: 20.57 },
	{ header: "NIF CABO", key: "nifCabo", width: 22.57 },
	{ header: "Nombre Cabo", key: "nombreCabo", width: 18.43 },
	{ header: "Personas", key: "totalPersonas", width: 12 },
];

const applyHeaderStyles = (worksheet) => {
	const headerRow = worksheet.getRow(1);
	headerRow.height = 18.75;

	headerRow.eachCell((cell) => {
		cell.font = {
			name: "Calibri",
			size: 14,
			color: { theme: 1 },
		};
		cell.fill = {
			type: "pattern",
			pattern: "solid",
			fgColor: { argb: "FFD9E2F3" },
		};
		cell.alignment = {
			horizontal: "left",
			vertical: "middle",
		};
	});
};

export const createPartesOperativosExcelWorkbook = async ({ rows = [] } = {}) => {
	const excelJsModule = await import("exceljs");
	const ExcelJS = excelJsModule.default || excelJsModule;
	const workbook = new ExcelJS.Workbook();

	workbook.creator = "Plana ETT";
	workbook.lastModifiedBy = "Plana ETT";
	workbook.created = new Date();
	workbook.modified = new Date();

	const worksheet = workbook.addWorksheet(SHEET_NAME);
	worksheet.columns = COLUMNS.map((column) => ({
		header: column.header,
		key: column.key,
		width: column.width,
	}));

	applyHeaderStyles(worksheet);

	if (!Array.isArray(rows) || rows.length === 0) {
		return workbook;
	}

	rows.forEach((row) => {
		worksheet.addRow({
			fecha: row.fecha || "",
			rfcte: row.rfcte || "",
			nombreEmpresa: row.nombreEmpresa || "",
			totalPersonas: Number(row.totalPersonas || 0),
			nifCabo: row.nifCabo || "",
			nombreCabo: row.nombreCabo || "",
		});
	});

	return workbook;
};
